import React from "react";

const SectionOne = ({ data }) => {
  return (
    <div className="max-w-screen-xl flex flex-col justify-center items-center py-10 gap-4 px-5 xl:px-0 xl:pt-[70px]">
      <p className="text-5xl text-blue-6 md:mb-10 mb-4">{data?.tagline}</p>
      <p className="md:text-xl text-md font-medium">
        {data?.description} <br />
        <br />
        Let us take the stress out of cleaning so you can enjoy a fresh, tidy
        space without lifting a finger.
      </p>

      <p className="text-lg text-left w-full mt-2 font-semibold text-blue-7">
        {data?.name} Task List:
      </p>

      <div className="w-full relative min-h-[350px] text-blue-7">
        <div className="flex flex-wrap md:w-[70%] w-full justify-between">
          {data.tasks.map((task, index) => (
            <p
              className="flex items-center gap-2 md:w-[50%] w-full text-lg mb-1"
              key={index}
            >
              <img
                src="/assets/images/services/dot.png"
                alt=""
                className="h-5 w-5 invert"
              />
              {task}
            </p>
          ))}
        </div>
        <img
          src="/assets/images/services/cleaning.webp"
          alt=""
          className="md:absolute right-2 md:top-4 w-[400px] object-contain z-[-1]"
        />
      </div>
    </div>
  );
};

export default SectionOne;
